var map = {
	"./decidim/avatar-multiuser.png": 17758,
	"./decidim/brands/facebook.svg": 3832,
	"./decidim/brands/google.svg": 13937,
	"./decidim/brands/twitter-x.svg": 81146,
	"./decidim/cc-badge.png": 46592,
	"./decidim/decidim-logo.svg": 92188,
	"./decidim/default-avatar.svg": 74244,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 33792,
	"./decidim/icons.svg": 31679,
	"./decidim/pattern.png": 66832,
	"./decidim/placeholder-card-g.svg": 88549,
	"./decidim/placeholder-card-l.svg": 96398,
	"./decidim/placeholder.jpg": 97213,
	"./decidim/remixicon.symbol.svg": 10801,
	"./decidim/vendor/social-share-button/douban.svg": 99280,
	"./decidim/vendor/social-share-button/email.svg": 49773,
	"./decidim/vendor/social-share-button/facebook.svg": 36659,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 65181,
	"./decidim/vendor/social-share-button/hacker_news.svg": 36909,
	"./decidim/vendor/social-share-button/linkedin.svg": 82821,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 4854,
	"./decidim/vendor/social-share-button/pinterest.svg": 9331,
	"./decidim/vendor/social-share-button/reddit.svg": 69223,
	"./decidim/vendor/social-share-button/telegram.svg": 69610,
	"./decidim/vendor/social-share-button/tumblr.svg": 41545,
	"./decidim/vendor/social-share-button/twitter.svg": 47388,
	"./decidim/vendor/social-share-button/vkontakte.svg": 97090,
	"./decidim/vendor/social-share-button/wechat.svg": 46381,
	"./decidim/vendor/social-share-button/whatsapp.svg": 9629,
	"./decidim/vendor/social-share-button/x.svg": 89293,
	"./decidim/vendor/social-share-button/xing.svg": 13395
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16781;